import React from 'react'
import { TabProps } from './Tabstrip.types'

const Tab: React.FC<TabProps> = ({ path, title, children }) => (
    <div data-testid='Tab' className={`r-tab-content`}>
        {children}
    </div>
)

export default Tab
